module.exports = __webpack_public_path__ + "static/media/VIEW.4d6c2ab0.svg";